import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import App from './App';

import config from './config';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      allowGuestAccess: false,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: config.cognito.OAUTH.domain,
          scopes: config.cognito.OAUTH.scope,
          redirectSignIn: [config.cognito.OAUTH.redirectSignIn],
          redirectSignOut: [config.cognito.OAUTH.redirectSignOut],
          responseType: config.cognito.OAUTH.responseType,
        },
      },
    },
  },
  API: {
    REST: {
      [config.apiGateway.NAME]: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Router>
    <App />
  </Router>
);
